import toast from 'react-hot-toast';

const styles = {
  backgroundColor: 'rgb(var(--color-surface-base) / 0.5)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  color: 'rgb(var(--color-text-primary))',
  borderRadius: '24px',
};

const toastSuccess = (msg: string) => {
  toast.dismiss();
  toast.success(msg, {
    duration: 5000,
    position: 'bottom-center',
    style: styles,
  });
};

const toastError = (msg: string) => {
  toast.dismiss();
  toast.error(msg, {
    duration: 5000,
    position: 'bottom-center',
    style: styles,
  });
};

const toastInfo = (msg: string) => {
  toast.dismiss();
  toast(msg, {
    duration: 5000,
    position: 'bottom-center',
    style: styles,
  });
};

const toastCustom = (msg: string, options?: any) => {
  toast.dismiss();
  toast(msg, {
    duration: 5000,
    position: 'bottom-center',
    style: styles,
    ...options,
  });
};

export {
  toastSuccess, toastError, toastInfo, toastCustom,
};
